<template>
  <canvas id="species-summary-chart" :style="{ maxWidth: maxWidth }"/>
</template>

<script>
import { Chart } from 'chart.js'
import { getChartColors } from '@/components/dashboard/ChartColors.js'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductSummaryChart',

  props: {
    speciesSummary: {
      type: Array,
      required: true
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },

  data: () => ({
    chart: null
  }),

  mounted () {
    this.buildChart()
  },

  watch: {
    speciesSummary: {
      handler () {
        this.buildChart()
      },
      deep: true
    },
    useMetricTons: {
      handler () {
        this.buildChart()
      }
    }
  },

  computed: {
    ...mapGetters('settlements', ['useMetricTons'])
  },

  methods: {
    buildChart () {
      if (this.chart) {
        this.chart.destroy()
      }
      const chartElement = document.getElementById('species-summary-chart')
      this.chart = new Chart(chartElement, {
        type: 'doughnut',
        data: this.getChartData(this.speciesSummary),
        options: {
          plugins: {
            legend: { display: false }
          }
        }
      })
    },

    getChartData (speciesSummary) {
      const labels = speciesSummary.map((ss) => ss.species)
      const mbfInfo = speciesSummary.map((ss) => parseFloat(ss.netMbf))
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: getChartColors(labels.length),
            data: mbfInfo
          }
        ]
      }
    }
  }
}
</script>
